import { render, staticRenderFns } from "./Ubicacion.vue?vue&type=template&id=056f4acb&scoped=true"
import script from "./Ubicacion.vue?vue&type=script&lang=js"
export * from "./Ubicacion.vue?vue&type=script&lang=js"
import style0 from "./Ubicacion.vue?vue&type=style&index=0&id=056f4acb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056f4acb",
  null
  
)

export default component.exports